__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "federated-state";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(788), __webpack_require__.e(344)]).then(() => (() => (__webpack_require__(6344))))));
			register("@rtk-query/graphql-request-base-query", "2.3.1", () => (Promise.all([__webpack_require__.e(448), __webpack_require__.e(120)]).then(() => (() => (__webpack_require__(120))))));
			register("graphql-request", "6.1.0", () => (Promise.all([__webpack_require__.e(72), __webpack_require__.e(68)]).then(() => (() => (__webpack_require__(2072))))));
			register("graphql", "16.8.1", () => (__webpack_require__.e(633).then(() => (() => (__webpack_require__(3633))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(619), __webpack_require__.e(132)]).then(() => (() => (__webpack_require__(5619))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(944), __webpack_require__.e(132), __webpack_require__.e(820)]).then(() => (() => (__webpack_require__(2944))))));
			register("react", "18.2.0", () => (__webpack_require__.e(60).then(() => (() => (__webpack_require__(9060))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};